<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Clientes Negativos</h3>
        </div>
        <!-- Page Header - Filters -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button type="button" class="btn btn-primary btn-sm mt-3" @click="OpenModalFilter()">
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{ countFilter }}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Clientes</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <b-input-group class="d-flex justify-content-end my-auto ml-2">
                  <h6 v-if="pagination.TotalItems > 0" class="m-0">
                    {{ pagination.TotalItems | number }}
                    {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                  </h6>
                  <div class="dropdown m-0" v-if="pagination.TotalItems > 1">
                    <button
                      class="btn btn-outline-secondary dropdown-toggle-ellipsis"
                      type="button"
                      v-b-tooltip.hover.right
                      title="Mais opções"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i class="fas fa-ellipsis-v"></i>
                    </button>
                    <div class="dropdown-menu" id="dropTableOptions" aria-labelledby="dropdownMenuButton">
                      <a
                        class="dropdown-item"
                        href="#"
                        :class="loadingReport ? 'disabled' : ''"
                        v-on:click.stop="GetReport($event)"
                      >
                        <template v-if="loadingReport">
                          <loader :small="true" :isLoading="loadingReport"></loader>
                        </template>
                        <template v-else>
                          <i class="fas fa-check mr-2"></i>
                          Gerar relatório
                        </template>
                      </a>
                    </div>
                  </div>
                </b-input-group>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0 text-left">
                      {{ labelId }}
                    </th>
                    <th scope="col" class="border-0">
                      {{ labelIdMerchantRoot }}
                    </th>
                    <th scope="col" class="border-0 text-left">
                      {{ labelName }}
                    </th>
                    <th scope="col" class="border-0">{{ labelIdentity }}</th>
                    <th scope="col" class="border-0">{{ CreatedDate }}</th>
                    <th scope="col" class="border-0">{{ labelAmount }}</th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(checkingAccount, index) in checkingAccountMerchants" :key="index">
                    <td></td>
                    <td v-if="checkingAccount.Merchant.IsBlocked" v-b-tooltip.hover title="Cliente bloqueado">
                      <i class="fas fa-ban fa-red"></i>
                    </td>
                    <td v-else></td>
                    <td class="text-left">{{ checkingAccount.Merchant.Id }}</td>
                    <td v-if="checkingAccount.Merchant.IdMerchantRoot > 0">
                      {{ checkingAccount.Merchant.IdMerchantRoot }}
                    </td>
                    <td v-if="checkingAccount.Merchant.IdMerchantRoot == 0">
                      <i :class="[GetIdMerchantRootClass(checkingAccount.Merchant.IdMerchantRoot)]"></i>
                    </td>
                    <td class="text-left">
                      {{ checkingAccount.Merchant.Name }}
                    </td>
                    <td>{{ checkingAccount.Merchant.Identity | identity }}</td>
                    <td>{{ checkingAccount.CreatedDate | date }}</td>
                    <td>
                      <span class="badge badge-danger">{{ checkingAccount.Amount | currency }}</span>
                    </td>
                    <td class="text-center">
                      <b-button
                        size="sm"
                        variant="outline-secondary"
                        v-b-tooltip.hover.left
                        title="Relatório de composição de reagendamento"
                        @click="GetReagendamentoReport(checkingAccount.Merchant.Id)"
                      >
                        <i class="fas fa-file-excel"></i>
                      </b-button>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      checkingAccountMerchants == undefined ||
                        checkingAccountMerchants == null ||
                        checkingAccountMerchants.length == 0
                    "
                  >
                    <td colspan="9">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="mFilter" title="Filtros" centered :no-close-on-backdrop="true" :no-close-on-esc="false">
      <d-form-row>
        <d-col md="6" class="form-group">
          <input
            :placeholder="labelName"
            type="text"
            class="form-control"
            v-model="filter.Name"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
        <d-col md="6" class="form-group">
          <the-mask
            class="form-control"
            type="tel"
            :mask="['###.###.###-##', '##.###.###/####-##']"
            v-model="filter.Identity"
            v-bind:placeholder="labelIdentity"
            v-on:keyup.enter.native="Filter()"
          />
        </d-col>
      </d-form-row>

      <template slot="modal-footer">
        <b-button variant="primary" class="btn btn-primary" v-b-tooltip.hover.bottom title="Pesquisar" @click="Filter()">
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";
import dateField from "../common/date-field";
export default {
  name: "checking-account-merchants",
  components: {
    dateField
  },
  data: function() {
    return {
      countFilter: 0,
      filter: {
        Identity: null,
        Name: null
      },
      labelIdentity: "CPF/CNPJ",
      labelName: "Cliente",
      labelId: "Id",
      labelIdMerchantRoot: "Id Marketplace",
      CreatedDate: " Última Transação",
      labelAmount: "Valor devedor",
      loadingList: false,
      loadingReport: false,
      pagination: {
        PageNumber: 1,
        RowsPerPage: 10,
        TotalItems: 0
      },
      checkingAccountMerchants: []
    };
  },
  computed: {},
  watch: {
    "pagination.PageNumber": function() {
      this.ListCheckingAccountMerchant();
    },
    "pagination.RowsPerPage": function() {
      this.ListCheckingAccountMerchant();
    }
  },
  mounted() {
    this.ListCheckingAccountMerchant();
  },
  methods: {
    OpenModalFilter: function() {
      this.$bvModal.show("mFilter");
    },
    GetIdMerchantRootClass: function(idMerchantRoot) {
      return idMerchantRoot == 0 ? "fas fa-minus" : "";
    },
    Filter: function() {
      this.$bvModal.hide("mFilter");
      this.ListCheckingAccountMerchant();
    },
    GetReport: function(ev) {
      ev.preventDefault();
      this.loadingReport = true;
      const params = {
        "Object.Merchant.Identity": this.filter.Identity,
        "Object.Merchant.Name": this.filter.Name
      };
      this.$store
        .dispatch("ReportCheckingAccountMerchantNegative", { params: params })
        .then(response => {
          if (response.UrlReport != null && response.UrlReport != undefined && response.UrlReport != "") {
            this.$makeToast("Aguarde a conclusão do download", "info", "Relatório gerado com sucesso");
            window.open(response.UrlReport, "_self");
          }
        })
        .catch(error => {
          this.$makeToast("Tente novamente mais tarde.", "danger", "Erro ao gerar o relatório", error);
        })
        .finally(() => {
          $("#dropTableOptions").dropdown("hide");
          setTimeout(() => {
            this.loadingReport = false;
          }, 1200);
        });
    },
    GetReagendamentoReport: function(merchantId) {
      this.$makeToast("Gerando o relatório de composição de reagendamento...", "info", "Aguarde");
      this.$store
        .dispatch("ReportReagendamentoComposition", { params: { idMerchant: merchantId } })
        .then(response => {
          if (response && response.UrlReport != null && response.UrlReport != undefined && response.UrlReport != "") {
            this.$makeToast("Aguarde a conclusão do download", "info", "Relatório gerado com sucesso");
            window.open(response.UrlReport, "_self");
          } else {
            this.$makeToast("Não há composição de reagendamento para este cliente.", "warning", "Nada a exportar");
          }
        })
        .catch(error => {
          this.$makeToast("Tente novamente mais tarde.", "danger", "Erro ao gerar o relatório", error);
        });
    },
    ListCheckingAccountMerchant: function() {
      this.countFilter = 0;
      if (hasValue(this.filter.Name)) this.countFilter++;
      if (hasValue(this.filter.Identity)) this.countFilter++;
      this.loadingList = true;
      let data = {
        ...this.pagination,
        ...{
          "Object.Merchant.Identity": this.filter.Identity,
          "Object.Merchant.Name": this.filter.Name
        }
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListCheckingAccountMerchantNegative", { params: data })
        .then(response => {
          this.checkingAccountMerchants = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao listar os clientes", error);
        })
        .finally(() => (this.loadingList = false));
    },
    ResetFilter: function() {
      this.filter = {
        Name: null,
        Identity: null
      };
      this.ListCheckingAccountMerchant();
    }
  }
};
</script>

<style scoped>
.fa-red {
  color: #ff0000;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/checkingAccountMerchants.vue